
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row">
    <div class="col">
      <div class="alert alert-success" [hidden]="!sent">
        <button class="close" type="button" (click)="sent = false"><span aria-hidden="true">&times;</span></button>Sent!
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
      <div class="alert alert-warning" *ngIf="!orderForm.header.orderAcceptanceCompleted"><span class="float-left"><span>Order Acceptance has not been completed for this project. Fix this in project setup or <a class="link" href="javascript:void(0)" (click)="notifyOrderAcceptance()"><span class="oi oi-envelope-closed"></span> send a notification</a> to the Contract Administrator</span></span>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p [hidden]="!canEdit">Make any necessary changes to the order form here before confirming.</p>
        <p [hidden]="canEdit">You have already confirmed this order form.</p>
      </div>
    </div>
  </div>
  <order-form [orderForm]="orderForm" [itsmAddress]="itsmAddress" [showReject]="false" [showCancel]="canCancelOrder" [allowEditing]="editableFields" [submitOrder]="submitOrder" (error)="error = $event[&quot;error&quot;]"></order-form>
</div>